import React,{useEffect,Component } from 'react'
import { useDispatch , useSelector } from 'react-redux'
import { Grid,Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Product from '../components/Product'
import Banner from '../components/Banner'
import { listProducts } from '../actions/productActions'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { spacing } from '@mui/system';
import Alert from '@mui/material/Alert';
import { ClassNames } from '@emotion/react';
// import Carousel from 'react-elastic-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
// import Products from '../products'
// import axios from 'axios'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';


const useStyles = makeStyles((theme) => ({
    root: {
      minHeight:'100vh',
      backgroundImage: "/images/assets/bg.jpg",
      flexGrow: 1,
    },
    paper: {
      padding: spacing(2),
      textAlign: 'center',
      color: "secondary",
    },
  }));

  function srcset(image, size, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${
        size * rows
      }&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  
const itemData = [
  {
    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
    title: 'Breakfast',
    rows: 2,
    cols: 2,
  },
  {
    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
    title: 'Burger',
  },
  {
    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
    title: 'Camera',
  },
  {
    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
    title: 'Coffee',
    cols: 2,
  },
  {
    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
    title: 'Hats',
    cols: 2,
  },
  {
    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
    title: 'Honey',
    author: '@arwinneil',
    rows: 2,
    cols: 2,
  },
  {
    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
    title: 'Basketball',
  },
  {
    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
    title: 'Fern',
  },
  {
    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
    title: 'Mushrooms',
    rows: 2,
    cols: 2,
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
  },
  {
    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
    title: 'Sea star',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    cols: 2,
  },
];


const HomeScreenGuest = () => {


    const classes = useStyles()
    const dispatch = useDispatch()

    const productList = useSelector((state) => state.productList)
    const { loading, error, products} = productList
    // console.log(products)
    // const dimensions = Dimensions.get('window');
    // const imageHeight = Math.round(dimensions.width * 9 / 16);
    // const imageWidth = dimensions.width;

    useEffect(() => {
      dispatch(listProducts())
    }, [dispatch])

    const [state, setState] = React.useState({
  
    dataBanner : [
      {"ID":"1","name":"1","image_url":"banner1.jpg"},
      {"ID":"2","name":"2","image_url":"banner2.jpg"},
      {"ID":"3","name":"3","image_url":"banner3.jpg"},

   ]
  
});

const Data = [
  {"img_name":"/images/assets/car5.jpg",
    "alt":"aaa"
  },
  {"img_name":"/images/assets/car4.jpg",
  "alt":"bbb"
}
];


// const carouselRef = React.useRef(null);
// const onNextStart = (currentItem, nextItem) => {
// if (currentItem.index === nextItem.index) {
// carouselRef.current.goTo(0);
// }
// };
// const onPrevStart = (currentItem, nextItem) => {
// if (currentItem.index === nextItem.index) {
// carouselRef.current.goTo(Data.length);
// }
// };

// const Loop = (currentItem) => {
// if (currentItem.index == Data.length - 1) {
// setTimeout(() => {
// carouselRef.current.goTo(0);
// }, 1500);
// }
// };

    return (
        <> 

{/* <Carousel sx={{mt:0 }}
        onChange={Loop}
        ref={carouselRef}
        onPrevStart={onPrevStart}
        onNextStart={onNextStart}
        disableArrowsOnEnd={false}
        enableAutoPlay autoPlaySpeed={1000}
        // itemPadding={[0, 5]}
        // className={classes.carousel}
      > */}
      <Carousel transitionTime={1000} 
                autoPlay={true} 
                infiniteLoop={true} 
                showArrows={true} 
                showThumbs={false}  
                sx={{mt:0 }}>
            {Data.map((img_data) => (
              <div>
                  <img 
                  style={{   height: window.innerHeight}}
                  src={img_data.img_name}
                  srcSet={img_data.img_name}
                  alt={img_data.alt}
                  loading="lazy"
                />
                <p className="legend">Legend 1</p>
              </div>
            ))}   
      </Carousel>
      <Container>
      <h1>Kategori..</h1>

      <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary="Pakian Pria" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton component="a" href="#simple-list">
              <ListItemText primary="Pakaian Wanita" />
            </ListItemButton>
          </ListItem>
        </List>

      </Container>
      <Container>
      <h1>Spesial Hari Ini</h1>
      
     
      {/* <Carousel> */}
      <Grid container justifyContent="center" spacing={3} sx={{mb:2}} >
      {state.dataBanner.map((product) => (
              <Grid item xs={3} key={product.ID}>
                  <Banner banner={product}/>
              </Grid>

          ))}
      </Grid>
      {/* </Carousel> */}
        
      </Container>
        
        <Container>
        <h1>Terlaris...</h1>
        {loading ? (
      <Loader />
      ) : error ? (

        // <Message variant='danger'>{error}</Message>
        <Alert severity="error" variant="filled">{error}</Alert>
      ) : (

        <Grid container spacing={2} >

        {products.map((product) => (
                <Grid item xs={2} key={product.ID}>
                    <Product product={product}/>
                </Grid>

            ))}
        </Grid>
        
      )}

        </Container>
        <Container>
        <h1>Banner</h1>
          <img src= {"/images/banner1.jpg"} />
        <ImageList
      sx={{  height: 900 }}
      variant="quilted"
      cols={4}
      rowHeight={121}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
          <img
            {...srcset(item.img, 121, item.rows, item.cols)}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
    </Container>
            
        </>
       
    )
}

export default HomeScreenGuest
